/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ComplianceIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 18.8571L2.57129 18.8571L2.57129 2.57141L17.9999 2.57141V8.57141"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M20.5716 14.25V20.5714L18.0001 19.7143L15.4287 20.5714L15.4287 14.25"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
      />
      <path
        d="M17.9999 15.4286C19.8934 15.4286 21.4284 13.8935 21.4284 12C21.4284 10.1064 19.8934 8.57141 17.9999 8.57141C16.1063 8.57141 14.5713 10.1064 14.5713 12C14.5713 13.8935 16.1063 15.4286 17.9999 15.4286Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6 6.85712L13.7143 6.85712"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6 10.2857L11.1429 10.2857"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6 13.7143L11.1429 13.7143"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};
